import React from "react";
import Input from "../helper/FieldInput";
import { FormControl } from "@mui/material";
import { Controller } from "react-hook-form";
import handleErrorMsg from "../helper/handleErrorMsg";
import useTranslation from "next-translate/useTranslation";

export default function InputController({
  name,
  control,
  rules,
  defaultValue = "",
  ...otherProps
}) {
  const { t } = useTranslation("common-locale");

  return (
    <FormControl fullWidth>
      <Controller
        control={control}
        name={name}
        rules={rules}
        render={({
          field: { value, ...otherRenderProps },
          fieldState: { error },
        }) => {
          return (
            <Input
              helperText={handleErrorMsg(error, t)}
              error={Boolean(error)}
              value={value ?? ""}
              {...otherProps}
              {...otherRenderProps}
            />
          );
        }}
        defaultValue={defaultValue}
      />
    </FormControl>
  );
}
